import * as Yup from "yup";

export const getAgentInitialValues = (isEditMode, agent, user) => ({
  name: agent?.name || "",
  phoneNumber: user?.phoneNumber?.[0] || "",
  assistants: agent?.settingIds || [],
});

export const agentValidationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .min(3, "Name must be at least 3 characters long.")
    .required("Name is required."),
  phoneNumber: Yup.string()
    .trim()
    .required("Phone Number is required."),
  assistants: Yup.array()
    .min(1, "At least one assistant is required")
    .required("At least one assistant is required"),
});